import { IOfferCard } from '../../../types/card';
import { getOfferArea } from './getOfferArea';
import { getFlatTitle } from './getFlatTitle';

export function getOfferName(offerCard: IOfferCard) {
  return [getFlatTitle, getOfferArea]
    .map(fn => fn(offerCard))
    .filter(Boolean)
    .join(', ');
}
